import { db } from "../firebase/config";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query, 
  where,
} from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

//get references of collections named 'quizzes'
const quizzesCollectionRef = collection(db, "quizzes");



export const createQuiz = async (
  quizTitle,
  pdf,
  courseName,
  assignedTo,
) => {
  const auth = getAuth();
  const user = auth.currentUser;
  
  if(!user) {
    throw new Error("Log in to create a quiz.")
  }

  const userId = user.uid;

  try {
    await addDoc(quizzesCollectionRef, {
      title: quizTitle,
      pdf: pdf,
      course: courseName,
      userId: userId,
      assignedTo: assignedTo,
    });
  } catch (error) {
    console.error("Error creating quiz: ", error);
  }
};

export const updateQuizName = async (id, name) => {
  const quizDoc = doc(db, "quizzes", id);
  const newFields = { title: name };
  await updateDoc(quizDoc, newFields);
};

export const updateQuizPDF = async (id, pdf) => {
  const quizDoc = doc(db, "quizzes", id);
  const newFields = { pdf: pdf };
  await updateDoc(quizDoc, newFields);
};

// export const updateQuizLocation = async (id, location) => {
//   const quizDoc = doc(db, "quizzes", id);
//   const newFields = { location: location };
//   await updateDoc(quizDoc, newFields);
// };

export const deleteQuiz = async (id) => {
  const quizDoc = doc(db, "quizzes", id);
  await deleteDoc(quizDoc);
};


// Reads all quizzes regardless of who is signed in
// May be useful to admin in the future 
export const readQuizzes = async () => {
  const data = await getDocs(quizzesCollectionRef);
  const quizzes = data.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  let list = [];

  quizzes.map((quiz) => {
    list.push({
      id: quiz.id,
      title: quiz.title,
      PDF: quiz.pdf,
      course: quiz.course,  
      assignedTo: quiz.assignedTo,
    });
  });

  return list;
};

export const fetchUserQuizzes = async () => {
  const auth = getAuth();
  
  // Promise is an object that represents an asynchronous operation
  // It stands for a value that will be resolved in the future
  // onAuthStateChanged must be used to account for page refreshes
  return new Promise((resolve, reject) => {
    onAuthStateChanged(auth, async (user) => {
      // No one is logged in
      if (!user) {
        reject(new Error("Log in."));
        return;
      }

      const userId = user.uid;
      const q = query(quizzesCollectionRef, where("userId", "==", userId));

      try {
        const querySnapshot = await getDocs(q);
        const userQuizzes = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Create a list to work with Table component
        let list = [];

        userQuizzes.map((quiz) => {
          list.push({
            id: quiz.id,
            userId: quiz.userId,
            title: quiz.title,
            PDF: quiz.pdf,
            course: quiz.course,
            assignedTo: quiz.assignedTo
          });
        });

        resolve(list);

      } catch (error) {
        console.error("Error querying user's quizzes: ", error);
        reject([]);
      }
    });
  });
};
